export const LOADING_UPDATE = 'LOADING_UPDATE';

export const loadingUpdate = (isLoading) => ({
    type: LOADING_UPDATE,
    payload: isLoading,
});
